<div class="campaign-toolbar">
  <!-- Search Input -->
  <div class="search-container">
    <div class="search-input">
      <div class="search-icon">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.5 11.5C9.26142 11.5 11.5 9.26142 11.5 6.5C11.5 3.73858 9.26142 1.5 6.5 1.5C3.73858 1.5 1.5 3.73858 1.5 6.5C1.5 9.26142 3.73858 11.5 6.5 11.5Z"
            stroke="#A7ABB3"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.5 12.5L10 10"
            stroke="#A7ABB3"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <input
        type="text"
        [value]="searchTerm"
        [placeholder]="searchPlaceholder"
        (input)="onSearchChange($event)"
        class="search-field"
      />
      <div *ngIf="searchTerm" class="clear-icon" (click)="clearSearch()">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5"
            stroke="#A7ABB3"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>

  <!-- Right Controls -->
  <div class="toolbar-controls">
    <!-- Location Dropdown - Only show when list view is selected -->
    <div class="location-dropdown" (document:click)="onDocumentClick($event)">
      <button class="location-button" (click)="toggleLocationDropdown()">
        <span class="location-text">{{ getSelectedLocationLabel() }}</span>
        <div class="chevron-icon" [class.rotated]="isLocationDropdownOpen">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.28033 7.38033L10 12.0996L14.7197 7.38033"
              stroke="#15172E"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </button>

      <div class="dropdown-menu" [class.open]="isLocationDropdownOpen">
        <div class="dropdown-header">
          <div class="header-title">Location</div>
        </div>

        <div class="location-list">
          <div
            *ngFor="let location of locations; trackBy: trackById"
            class="location-item"
            (click)="onLocationToggle(location.value)"
          >
            <div class="checkbox" [class.checked]="isLocationSelected(location.value)">
              <svg
                *ngIf="isLocationSelected(location.value)"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 3L4.5 8.5L2 6"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span class="location-label">{{ location.label }}</span>
          </div>
        </div>

        <div class="dropdown-actions">
          <button class="action-link" (click)="onLocationClear()">Clear</button>
          <div class="action-buttons">
            <button class="btn btn-secondary" (click)="onLocationCancel()">Cancel</button>
            <button class="btn btn-primary" (click)="onLocationApply()">Apply</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Filter Button -->
    <button class="filter-button" (click)="onFilterClick()">
      <span class="filter-text">Filter</span>
      <div class="filter-icon">
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.99967 10.4999C4.55765 10.4999 4.13372 10.3243 3.82116 10.0118C3.5086 9.6992 3.33301 9.27528 3.33301 8.83325C3.33301 8.39122 3.5086 7.9673 3.82116 7.65474C4.13372 7.34218 4.55765 7.16659 4.99967 7.16659M4.99967 10.4999C5.4417 10.4999 5.86563 10.3243 6.17819 10.0118C6.49075 9.6992 6.66634 9.27528 6.66634 8.83325C6.66634 8.39122 6.49075 7.9673 6.17819 7.65474C5.86563 7.34218 5.4417 7.16659 4.99967 7.16659M4.99967 10.4999V17.1666M4.99967 7.16659V3.83325M9.99967 15.4999C9.55765 15.4999 9.13372 15.3243 8.82116 15.0118C8.5086 14.6992 8.33301 14.2753 8.33301 13.8333C8.33301 13.3912 8.5086 12.9673 8.82116 12.6547C9.13372 12.3422 9.55765 12.1666 9.99967 12.1666M9.99967 15.4999C10.4417 15.4999 10.8656 15.3243 11.1782 15.0118C11.4907 14.6992 11.6663 14.2753 11.6663 13.8333C11.6663 13.3912 11.4907 12.9673 11.1782 12.6547C10.8656 12.3422 10.4417 12.1666 9.99967 12.1666M9.99967 15.4999V17.1666M9.99967 12.1666V3.83325M14.9997 7.99992C14.5576 7.99992 14.1337 7.82432 13.8212 7.51176C13.5086 7.1992 13.333 6.77528 13.333 6.33325C13.333 5.89122 13.5086 5.4673 13.8212 5.15474C14.1337 4.84218 14.5576 4.66659 14.9997 4.66659M14.9997 7.99992C15.4417 7.99992 15.8656 7.82432 16.1782 7.51176C16.4907 7.1992 16.6663 6.77528 16.6663 6.33325C16.6663 5.89122 16.4907 5.4673 16.1782 5.15474C15.8656 4.84218 15.4417 4.66659 14.9997 4.66659M14.9997 7.99992V17.1666M14.9997 4.66659V3.83325"
            stroke="#15172E"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <!-- Filter Count Badge -->
      <div *ngIf="getActiveFilterCount() > 0" class="filter-badge">
        {{ getActiveFilterCount() }}
      </div>
    </button>
  </div>
</div>

<!-- Campaign Filter Modal -->
<app-campaign-filter-modal
  [isVisible]="isFilterModalOpen"
  [currentLocationLabels]="selectedLocationLabels"
  [activeFilters]="activeFilters"
  (close)="onFilterModalClose()"
  (applyFilters)="onFiltersApplied($event)"
  (clearFilters)="onFiltersCleared()"
  (locationSelectionChanged)="onLocationSelectionFromModal($event)"
></app-campaign-filter-modal>
